import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useLocation} from 'react-router-dom';

import {navigationActions} from '../index';


function DispatchOnRouteChange() {

    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {

        dispatch(navigationActions.onRouteChange(location));

    }, [location]);

    return null;
}


export default DispatchOnRouteChange;
